import styled from 'styled-components';
const DamageExpiryStyled = styled.div`
  @media print{
    &.damage-expiry {
      .portrait-type{
        .print-body{
          height: 100% !important;
        padding:0 !important;
        margin:0.28in 0.28in !important;
        page-break-after: always;
        .mdc-layout-grid__inner{
          display:flex;
        }
        .mdc-layout-grid__cell{
          width:32.2%;
          overflow:hidden;
        }
          .fixed-table-wrapper{
            height:1445px !important;
            table{
              height:100%;
              .blank-tr{
                height:24px !important;
                border:0;
              }
              thead{
                th{
                  font-size: 14px !important;
                }
              }
              tbody{
                td{
                  font-size: 14px !important;
                  width:60px !important;
                  min-width:60px !important;
                  max-width:60px !important;
                  &.title{
                    width:260px !important;
                    min-width:260px !important;
                    max-width:260px !important;
                    white-space:normal !important;
                  }
                  &:last-child{
                    font-weight:500;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media print and (max-width:5.83in) {
    &.ledger-report-details .print-body{
        height: 100% !important;
        padding:0 !important;
        margin:0.4in 0.4in !important;
    }
  }

`;
export default DamageExpiryStyled;
